<template>
  <app-panel
    title="Terms and Conditions"
    class="container"
    v-on:next="next"
    v-on:prev="prev"
    v-bind:showBack="true"
    nextText="Complete"
    v-bind:showNext="true"
  >
    <p class="legal-text">
      This offer is valid for new accounts only and is subject to credit
      approval. You must be at least 18 years of age (19 in Alabama), be a
      permanent resident of the U.S., and reside in the United States. We may
      order credit reports in connection with processing your application and
      any update, renewal or extension of credit. Upon request, we will tell you
      the name and address of any consumer reporting agency that furnished a
      report on you. You consent to the obtaining of such reports by submitting
      an application.
    </p>
    <p class="legal-text">
      Ohio Residents: The Ohio laws against discrimination require that all
      creditors make credit equally available to all credit worthy customers,
      and that credit reporting agencies maintain separate credit histories on
      each individual upon request. The Ohio Civil Rights Commission administers
      compliance with this law.
    </p>
    <p class="legal-text">
      New York Residents: For questions, call us at 1.800.830.7820. New York
      residents may contact the New York State Department of Financial Services
      by calling (800) 342-3736 or by visiting its website,
      https://www.dfs.ny.gov for free information on comparative credit card
      rates, fees and grace periods.
    </p>
    <p class="legal-text">
      Wisconsin Residents: No marital property agreement, unilateral statement,
      or court decree adversely affects our rights, unless you give us a copy of
      such agreement, statement or court order before we grant you credit, or we
      have actual knowledge of its terms before your account is opened. If you
      are married, by submitting your application you are confirming that this
      credit card application is being incurred in the interest of your marriage
      and your family. If you are a married Wisconsin resident, please mail the
      name and address of your spouse to us at Valliani Credit, 4802 E. Ray
      Road, Suite 23-221, Phoenix, AZ 85044.
    </p>
    <p class="legal-text">
      By giving us your mobile telephone number, we have your permission to
      contact you at that number regarding all accounts you have with us. Your
      consent allows us to use text messaging, artificial or prerecorded voice
      messages and automatic dialing technology for informational and account
      service calls, but not for telemarketing or sales calls. It may include
      calls from companies working on our behalf to service your account.
      Message and data rates may apply. You can change these preferences at any
      time by contacting us at 1-800-830-7820.
    </p>
    <p class="legal-text">
      IMPORTANT INFORMATION ABOUT OPENING AN ACCOUNT: To help the government
      fight the funding of terrorism and money laundering activities, Federal
      law requires all financial institutions to obtain, verify, and record
      information that identifies each person who opens an account. What this
      means for you: When you open an account, we will ask for your name,
      address, date of birth, and other information that will allow us to
      identify you. We may also ask to see your driver's license or other
      identifying documents.
    </p>
    <p class="legal-text">
      By submitting this application you agree that the information furnished on
      this application is complete and accurate, to the best of your knowledge,
      and that you
    </p>

    <p class="legal-text">
      <b-form-checkbox v-model="form.readEsign"
        >Have read and agree to our ESign Consent and can meet the hardware and
        software requirements.</b-form-checkbox
      >
      <br />
      <b-form-checkbox v-model="form.readAgreement"
        >Have read and understood the important rate, fee and other cost
        information included in the</b-form-checkbox
      >
      <a :href="state_terms[state]" target="_blank"
        >Valliani Credit Retail Installment Credit Agreement</a
      >
      , and, if approved, agree to be bound by that Agreement. Please note, this
      Agreement contains an arbitration agreement, a class action waiver, and a
      jury trial waiver.
    </p>
    <signature-pad ref="signaturePad" />
    <b-alert show variant="danger" v-for="error in errors" v-bind:key="error">{{
      error
    }}</b-alert>
  </app-panel>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import az_pdf from "../assets/terms/Terms AZ.pdf";
import ca_pdf from "../assets/terms/Terms CA.pdf";
import de_pdf from "../assets/terms/Terms DE.pdf";
import il_pdf from "../assets/terms/Terms IL.pdf";
import ma_pdf from "../assets/terms/Terms MA.pdf";
import md_pdf from "../assets/terms/Terms MD.pdf";
import nj_pdf from "../assets/terms/Terms NJ.pdf";
import ny_pdf from "../assets/terms/Terms NY.pdf";
import appPanel from "./appPanel.vue";
import signaturePad from "./signaturePad.vue";
export default {
  components: {
    Datepicker,
    appPanel,
    signaturePad,
  },
  data() {
    return {
      form: {
        employer: "",
        spouseName: "",
        spouseAddress: "",
        readEsign: false,
        readAgreement: false,
      },
      errors: [],
      state_terms: {
        33: az_pdf,
        20: ca_pdf,
        2: de_pdf,
        // IL
        28: il_pdf,
        32: ma_pdf,
        37: md_pdf,
        18: ny_pdf,
        10: nj_pdf,
        // Others
        // PA
        19: ny_pdf,
        // VT
        27: ny_pdf,
        // CT
        35: ny_pdf,
        // RI
        44: ny_pdf,
        // DC
        3: ny_pdf,
        // FL
        7: ny_pdf,
      },
    };
  },
  props: ["state"],
  methods: {
    validate() {
      this.errors = [];
      if (!this.$refs.signaturePad.isValid())
        this.errors.push("Valid Signature Required");
      if (!this.form.readEsign || !this.form.readAgreement)
        this.errors.push("Please read completely before continuing");
      if (!this.errors.length) return true;
    },
    next() {
      let data = { signature: this.$refs.signaturePad.value() };
      if (this.form.spouseName.length) data.nameOfSpouse = this.form.spouseName;
      if (this.form.spouseAddress.length)
        data.addressOfSpouse = this.form.spouseAddress;
      if (this.validate()) this.$emit("next", data);
    },
    prev() {
      this.$emit("prev");
    },
  },
};
</script>
<style>
.alert {
  margin-top: 5px;
}
.legal-text {
  text-align: justify;
  text-justify: inter-word;
  font-family: sans-serif;
  font-size: 14px;
}
</style>
